import { Tween } from '@tweenjs/tween.js'
import { type ArgumentsType } from '@vueuse/core'

export const autoRunUntilComplete = (tw: Tween) => {
  const nextTick = (time: ArgumentsType<FrameRequestCallback>[number]) => {
    if (tw.isPaused()) return
    tw.update(time)
    window.requestAnimationFrame(nextTick)
  }

  window.requestAnimationFrame(nextTick)
}
